import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logout } from '../slices/authSlice';

const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithLogout = async (args, api, extraOptions) => {
  const result = await baseQuery(args, api, extraOptions);

  if (result.error && result.error.status === 401) {
    api.dispatch(logout());
    window.location.href = '/login';
  }

  return result;
};

export const featuresApi = createApi({
  reducerPath: 'featuresApi',
  baseQuery: baseQueryWithLogout,
  endpoints: (builder) => ({
    getFeatures: builder.query({
      query: () => '/merchant/features',
      // Unwrap { success, data: { features } } → string[].
      transformResponse: (response) => response?.data?.features || [],
    }),
  }),
});

export const { useGetFeaturesQuery } = featuresApi;
